import React, { useState, useEffect } from 'react';
import ItemYORP from './ItemYORP';
import Calendar from './Calendar';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import {FiPlusCircle, FiCheckCircle} from "react-icons/fi"

import { db, auth } from '../functions/firebaseFunctions';
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const EditEventScreen = () => {

  const [sel, select] = useState('House Party');
  const [publ, SetPubl] = useState('Public');
  const { eventId } =  useParams()
  const uid = auth.currentUser?.uid
  
  const [name, setName] = useState('');
  const [changes, setChanges] = useState(false);
  const navigateTo = useNavigate();
  const [Err, setErr] = useState(null);
  const [eventUID, setEventUID] = useState('');

  const now = new Date();
  const types = ['House Party', 'Bar Mitzvah', 'Corp. Event', 'Birthday', 'Yacht Party', 'Holiday Party', 'Wedding', 'Bar/Club', 'Other'];

  const [date, setDate] = useState(now);
  const [Tstart, setTStart] = useState(now);
  const [Tend, setTEnd] = useState(new Date(now.valueOf() + 3600000));
  const [calVis, setCalVis] = useState(false);
  useEffect(() => {
    if (eventId != 'new') {
      db.collection('events').doc(eventId)
        .get()
        .then((doc) => {

          const val = doc.data();
          setEventUID(val.uid)
          setName(val.name);
          select(val.type);
          setDate(new Date(val.start.toDate()?.toDateString()));
          setTStart(val.start.toDate());
          setTEnd(val.end.toDate());
        }).catch(e => { setErr(e); });
    }
  }, []);
  const nameIn = async event => {
    event.preventDefault();
    const nameInput = document.querySelector('#name');
    const name = nameInput.value;
    setName(name);
    setChanges(true);
    setErr(null);
    
    if (sel && name && date != now && Tstart != now) {
      let start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Tstart.getHours(), Tstart.getMinutes());
      let end;
      if (Tend.getDate() > Tstart.getDate()) {
        end = new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1), Tend.getHours(), Tend.getMinutes());
      } else {
        end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Tend.getHours(), Tend.getMinutes());
      }
      if (eventId == 'new') {
        const event = {
          name: name,
          type: sel,
          start: start,
          end: end,
          public: publ == 'Public' ? true : false,
        };
        const booking = {
          owner: uid,
          date: start,
          end: end,
        };
        var ref = db.collection('events').doc();
        var docid = ref.id;

        ref.set({
          ...event,
          uid,
          docid,
        })
          .then(() => {
            db.collection('events').doc(docid).get().then((e) => {
              event.start = e.data().start;
              event.end = e.data().end;

              db.collection('bookings').doc(docid).set(booking)
                .then(() => {
                  navigateTo('/Profile/dashboard');
                }).catch((err) => console.log('err', err));
            });
          })
          .catch((error) => {
            console.error('Error writing document: ', error);
          });

      }
      else {
        const event = {
          name: name,
          type: sel,
          start: start,
          end: end,
          public: publ == 'Public' ? true : false,
        };
        db.collection('events').doc(eventId).set({
          ...event,
        }, { merge: true })
          .then(() => {
            navigateTo('/Profile/dashboard');
          })
          .catch((error) => {
            console.error('Error writing document: ', error);
          });

      }
    } else {
      if (!sel) { setErr({ code: 'NoSel', message: 'Select the type of event' }); }
      if (!name) { setErr({ code: 'NoName', message: 'Give a name to the event' }); }
      if (date == now || Tstart == now) { setErr({ code: 'NoTime', message: 'Select date and time for the event' }); }
    }
    setChanges(false);
  }
  return (
    <div className='EventScreen'>
      {/* <div style={{ height: 2, width: '100%',  }} /> */}
      <div style={{display: 'flex', flexDirection: 'column', justifySelf: 'center', padding: 10,  width: '550px'}}>
        <h1 style={{textAlign: 'center', marginBlockEnd: 15}}>{eventId === 'new' ? 'New event' : name}</h1>
        {eventUID === uid || 'new' ? <div
          style={{ flex: 1, flexDirection: 'column' }}
          behavior="padding"
          // keyboardVerticalOffset={70}
        >
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
          <div className='EditEventDashboard' style={{ display: 'grid', flexDirection: 'row', gridTemplateColumns: '1fr 1fr', gap: 6}}>
            <ItemYORP title={'Private'}
              icon={{ name: 'lock' }}
              sel={publ}
              onClick={() => {
                SetPubl('Private');
              }} />
            <ItemYORP title={'Public'}
              icon={{ name: 'unlock' }}
              sel={publ}
              onClick={() => {
                SetPubl('Public');
              }} />
          </div>
          <div style={{ flexDirection: 'row' }}>
            <form onSubmit={nameIn} style={{width: '100%', padding: 5, display: 'flex', flexDirection: 'column'}}>
              <label htmlFor="name" className="label" >
                Event Name:
                <input 
                  name='name'
                  id='name'
                  className="editable"
                  type="text"
                  defaultValue={name}
                  placeholder={"Enter Event Name"}
                  onBlur={(event) => {
                    const newName = event.target.value;
                    if (newName !== name) {
                      setChanges(true);
                    } else {
                      setChanges(false);
                    }
                  }}
                />
              </label>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignContent: 'center', padding: 5 }}
            onClick={() => {
              if (calVis) { setCalVis(false); setChanges(true); } else { setCalVis(true); }
            }}>
            <p className='BrowseButton' style={{cursor: 'pointer'}}>Dates: </p>
            <p style={{ color: 'white', textAlign: 'center', cursor: 'pointer', }}>{calVis ? 'Done' : `${months[date.getMonth()]} ${date.getDate()} - ${weekDays[date.getDay()]}`}</p>
          </div>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
          {calVis && <Calendar date={date} setDate={setDate} />}
          {/* <Time start={Tstart} setStart={setTStart} end={Tend} setEnd={setTEnd} date={date} setChanges={setChanges} /> */}
          <div >
            <p style={ { margin: 10, color: 'var(--wht)', textAlign: 'center' }}>Select type of event: </p>
            <div className='EditEventButtons'>
              {types.map(item => <ItemYORP title={item}
                key={item}
                sel={sel}
                onClick={() => {
                  select(item); setChanges(true); setErr(null);
                }} />)}
            </div>
          </div>
            {changes &&
              <button 
                style={{
                  color: "var(--wht)",
                  alignSelf: 'center',
                  borderWidth: 0,
                  justifyContent: 'center',
                  alignContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifySelf: 'center',
                  marginBlockStart: 10,
                }}
                // color="white"
                type='submit'
              >
                {eventId === 'new' ? 'Create event' : <p className='BrowseButton' >Save changes </p>}{eventId === 'new' ? <FiPlusCircle style={{marginInline: 5,}} className='BrowseButton'/> : <FiCheckCircle style={{marginInline: 5,}} className='BrowseButton'/>}
              </button>
            }
            </form>
          </div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
          </div>
        </div> : 
        <div style={{width: '100%'}}> 
          <p style={ { margin: 10, color: 'var(--red)', textAlign: 'center', fontSize: 18 }}>
            You can not edit this event
          </p>
        </div>}
      </div>
    </div>
  );
};

export default EditEventScreen;
